import {
    createDocument,
    getAllData,
    updateDocumentByID,
  } from "apis/customApiHandler";
  import { Fragment, useCallback, useEffect, useState } from "react";
  import { useSelector } from "react-redux";
  import { Button, Input, Select } from "styled";
  import { TD, TH } from "styled/table";
  import { BiCloudDownload } from "react-icons/bi";
  import axios from "apis/axios";
  import ReactSelect from "react-select";
  import Spinner from "components/Spinner";
  import exportExcel from "utils/exportExcel";
  import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
  import getFormattedDate from "utils/helpers";
  import Modal from "components/Modal";
  import { useFormik, Form, FormikProvider } from "formik";
  import InputField from "components/formik/InputField";
  import { useQuery, useQueryClient } from "react-query";
  import toast from "react-hot-toast";
  
  import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
  
  const WheelAlignmentReport = () => {
    const dateFromConst = new Date();
    dateFromConst.setMonth(new Date().getMonth() - 4);
    const ids = window.location.search.split("=")[1];
    const [selectedFleets, setSelectedFleets] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [fleetMap, setFleetMap] = useState({});
    const [dateFrom, setDateFrom] = useState(getFormattedDate(dateFromConst));
    const [dateTo, setDateTo] = useState(getFormattedDate());
    const [page, setPage] = useState(1);
    const [kmFrom, setKmFrom] = useState("");
    const [kmTo, setKmTo] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [contractType, setContractType] = useState("All");
    const [alignment, setAlignment] = useState("All");
    const [rotation, setRotation] = useState("All");
    const [replacement, setReplacement] = useState("All");
    const [reportData, setReportData] = useState("");
    const [downloading, setDownloading] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const limit = 20;
    const [selectedAlignmentCenter, setSelectedAlignmentCenter] = useState([]);

    const getData = async (pg) => {
      setIsLoading(true);
      const dt = await createDocument("/report/wheelAlignmentReport", {
        ...(selectedFleets?.includes("all")
          ? {
            fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
              hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
        ...(ids && {
          ids,
        }),
        ...(searchQuery && { searchQuery }),
        ...(contractType !== "All" && contractType !== "" && { contractType }),
        dateFrom,
        dateTo,
        kmFrom,
        kmTo,
        wheelAlignment: alignment,
        tyreReplacement: replacement,
        tyreRotation: rotation,
        page: pg ? pg : page,
        download: 0,
        limit: limit,
        ...(selectedAlignmentCenter?.includes("all")
        ? {
          alignmentCenter: getAlignmentCenterOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedAlignmentCenter.length && {
            alignmentCenter: selectedAlignmentCenter.map((alignmentCenter) => alignmentCenter).join(","),
          }),
        });
      // console.log(dt)
      setData(dt);
      setIsLoading(false);
    };
  
    useEffect(() => {
      if (
        (selectedFleets.length === 0 || selectedHubs.length === 0) &&
        !searchQuery
      ) {
        // console.log("");
      } else getData(page);
    }, [page]);
  
    const { data: allFleets } = useQuery([`/customer-fleet`], () =>
      getAllData("/customer-fleet", {
        limit: 3000,
      })
    );
    const { data: allHubs } = useQuery([`/customer-hub`], () =>
      getAllData("/customer-hub", {
        limit: 3000,
      })
    );
  
    const { data: allAlignmentCenter } = useQuery([`/alignment-center`], () =>
      getAllData("/alignment-center", {
        limit: 3000,
      })
    );
    const getDownloadData = async () => {
      setDownloading(true);
      try{
      const dt = await createDocument("/report/wheelAlignmentReport", {
        ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
        ...(ids && {
          ids,
        }),
        ...(searchQuery && { searchQuery }),
        ...(contractType !== "All" && contractType !== "" && { contractType }),
        dateFrom,
        dateTo,
        kmFrom,
        kmTo,
        wheelAlignment: alignment,
        tyreReplacement: replacement,
        tyreRotation: rotation,
        download: 1,
        ...(selectedAlignmentCenter?.includes("all")
        ? {
          alignmentCenter: getAlignmentCenterOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedAlignmentCenter.length && {
            alignmentCenter: selectedAlignmentCenter.map((alignmentCenter) => alignmentCenter).join(","),
          }),
      });
      console.log("dt---",dt)
      if (dt?.data) 
        {setReportData(dt.data);
        }
      exportExcel(
        dt?.data?.map((x, idx) => ({
          "S.N": idx + 1,
          "Alignment Date": x?.inspectionDate,
          "Fleet": x?.fleetInfo ? `${x.fleetInfo} (${x.fleetCity || "--"})` : "--",
          "Alignment Center": x?.wheelAlignment?.alignmentCenter,
          "Vehicle Number": x?.vehicleInfo?.registrationNumber,
          "killometer Covered":
            x?.killometerTravelled,
            "Before Alignment Date": x?.previousAlignmentDate,
            "Total TOE (Before)": x?.wheelAlignment?.totalTOE.before,	
            "Total TOE (After)"	:x?.wheelAlignment?.totalTOE.after,
            "Thrust angle (Before)"	:x?.wheelAlignment?.thrustAngle.before,
            "Thrust angle (after)"	:x?.wheelAlignment?.thrustAngle.after,
            "Scrub angle (Before)"	:x?.wheelAlignment?.scrubAngle.before,
            "Scrub angle (After)": x?.wheelAlignment?.scrubAngle.after,
        })),
        "wheel-alignment-report.xlsx"
      );
      } catch(err) {
        console.log("err",err)
      }
      finally{
        setDownloading(false)
      }
    };

    const getFleetOptions = useCallback(() => {
      if (allFleets && allFleets.data && allFleets.data.length) {
        return [
          {
            label: "All",
            value: "all",
          },
          {
            label: "Clear",
            value: "clear",
          },
          ...allFleets?.data?.map((fleet) => {
            return {
              value: fleet._id,
              label: fleet.fleetName,
            };
          }),
        ];
      }
    }, [allFleets]);
  
    const getHubOptions = useCallback(() => {
      if (allHubs && allHubs.data && allHubs.data.length) {
        return [
          ...selectedFleets?.length ? [{
            label: "All",
            value: "all",
          }]: [],
          ...selectedFleets?.length ? [{
            label: "Clear",
            value: "clear",
          }]: [],
          ...(selectedFleets?.includes("all") ? 
          allHubs?.data?.length &&
            allHubs?.data
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              }) : 
          allHubs?.data?.length &&
            allHubs?.data
              ?.filter((hub) => {
                const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                );
  
                return selectedFleetsVal?.some(
                  (fleet) => fleet.fleetCode === hub.fleetCode
                );
              })
              ?.map((hub) => {
                return {
                  value: hub._id,
                  label: hub.hubName,
                };
              })),
        ];
      }
    }, [allFleets, allHubs, selectedFleets]);
  
    const getAlignmentCenterOptions = useCallback(() => {
      // console.log(allAlignmentCenter);
      if (allAlignmentCenter && allAlignmentCenter.data && allAlignmentCenter.data.length) {
        return [
          {
            label: "All",
            value: "all",
          },
          {
            label: "Clear",
            value: "clear",
          },
          ...allAlignmentCenter?.data?.map((item) => {
            return {
              value: item._id,
              label: item.name,
            };
          }),
        ];
      }
    }, [allAlignmentCenter]);

    return (
      <div>
        <div className="flex flex-col text-gray-500">
          <div className="w-full px-8 flex justify-center items-center gap-4">
            <label className="w-full py-3">
              Select Fleets
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                      borderColor: "rgb(34 197 94)",
                    },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getFleetOptions()}
                value={
                  selectedFleets &&
                  selectedFleets?.map((fleet) => {
                    return {
                      value: fleet,
                      label: getFleetOptions()?.find(
                        (item) => item?.value === fleet
                      )?.label,
                    };
                  })
                }
                onChange={(value) => {
                  let allValues = value?.map((item) => item.value);
                  if (allValues?.includes("clear")) {
                    // console.log(allValues)
                    setSelectedFleets([]);
                    setSelectedHubs([]);
                    return;
                  }
                  if (
                    !selectedFleets?.includes("all") &&
                    allValues.includes("all")
                  ) {
                    setSelectedFleets(["all"]);
                    return;
                  }

                  if (selectedFleets.includes("all")) {
                    // console.log("first");
                    // console.log(getFleetOptions())
                    value = value.filter((item) => item.value !== "all");
                  }

                  let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  let selectedHubsVal = allHubs?.data?.filter((hub) =>
                    selectedHubs?.map((item) => item)?.includes(hub._id)
                  );

                  setSelectedHubs(
                    selectedHubsVal
                      ?.filter((hub) =>
                        selectedFleetsVal?.find(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        )
                      )
                      .map((hub) => hub._id)
                  );

                  // console.log({allHubs, selectedHubs})

                  setSelectedFleets(value.map((fleet) => fleet.value));
                }}
                name="fleets"
                isMulti={true}
              />
            </label>
            <label className="w-full py-3">
              Select Hubs
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                      borderColor: "rgb(34 197 94)",
                    },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getHubOptions()}
                value={
                  selectedHubs &&
                  selectedHubs?.map((hub) => {
                    // console.log({hub})
                    return {
                      value: hub,
                      label: getHubOptions()?.find((item) => item.value === hub)
                        ?.label,
                    };
                  })
                }
                onChange={(value) => {
                  const allValues = value?.map((item) => item.value);
                  // console.log({allValues})
                  if (allValues.includes("clear")) {
                    setSelectedHubs([]);
                    return;
                  }
                  if (
                    !selectedHubs?.includes("all") &&
                    allValues.includes("all")
                  ) {
                    let selectedFleetCodes = allFleets?.data
                      ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                      ?.map((fleet) => fleet.fleetCode);

                    const selectedHubsData = allHubs?.data?.filter((hub) =>
                      selectedFleetCodes?.includes(hub.fleetCode)
                    );

                    const mp = fleetMap;
                    selectedHubsData.map((hub) => {
                      if (selectedFleetCodes?.includes(hub.fleetCode)) {
                        if (mp[hub.fleetCode] === undefined)
                          mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                      }
                    });

                    setFleetMap(mp);
                    setSelectedHubs(["all"]);
                  } else {
                    // console.log({value})
                    value = value.filter((value) => value.value !== "all");
                    // console.log({value})
                    let selectedFleetCodes = allFleets?.data
                      ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                      ?.map((fleet) => fleet.fleetCode);
                    // console.log({allValues})

                    const selectedHubsData = allHubs?.data?.filter((hub) =>
                      allValues?.includes(hub._id)
                    );
                    const mp = {};
                    selectedHubsData.map((hub) => {
                      mp[hub.fleetCode] = [];
                    });

                    selectedHubsData.map((hub) => {
                      if (selectedFleetCodes?.includes(hub.fleetCode)) {
                        if (mp[hub.fleetCode] === undefined)
                          mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                      }
                    });

                    setFleetMap(mp);
                    setSelectedHubs(value.map((hub) => hub.value));
                  }
                }}
                name="hubs"
                isMulti={true}
              />
            </label>
            <label className="w-full py-3">
              Select Alignment Center
              <ReactSelect
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: "transparent",
                    minWidth: "100%",
                    "&:hover": {
                      borderColor: "rgb(34 197 94)",
                    },
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getAlignmentCenterOptions()}
                value={
                  selectedAlignmentCenter &&
                  selectedAlignmentCenter?.map((alignmentCenter) => {
                    return {
                      value: alignmentCenter,
                      label: getAlignmentCenterOptions()?.find(
                        (item) => item?.value === alignmentCenter
                      )?.label,
                    };
                  })
                }
                onChange={(value) => {
                  let allValues = value?.map((item) => item.value);
                  if (allValues?.includes("clear")) {
                    setSelectedAlignmentCenter([]);
                    return;
                  }
                  if (
                    !selectedAlignmentCenter?.includes("all") &&
                    allValues.includes("all")
                  ) {
                    setSelectedAlignmentCenter(["all"]);
                    return;
                  }

                  if (selectedAlignmentCenter.includes("all")) {
                    value = value.filter((item) => item.value !== "all");
                  }

                  setSelectedAlignmentCenter(value.map((alignmentCenter) => alignmentCenter.value));
                }}
                name="alignmentCenter"
                isMulti={true}
              />
            </label>
          </div>
          <div className="w-full px-8 flex justify-start items-center gap-4">
            <label>
              Start Date{" "}
              <Input
                type="date"
                max={getFormattedDate()}
                name="dateFrom"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
              />
            </label>
            <label>
              End Date{" "}
              <Input
                type="date"
                min={getFormattedDate(dateFrom)}
                max={getFormattedDate(
                  new Date(
                    Math.min(
                      new Date(dateFrom).getTime() + 124 * 24 * 60 * 60 * 1000,
                      new Date().getTime()
                    )
                  )
                )}
                name="dateTo"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
              />
            </label>
            <label>
              Vehicle Number
              <Input
                type="text"
                name="searchQuery"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </label>
            <Button
              type="button"
              className='mt-5'
              bgPrimary
              onClick={() => {
                setPage(1);
                getData();
              }}
              disabled={
                (selectedFleets.length === 0 || selectedHubs.length === 0) &&
                !searchQuery
              }
            >
              Search
            </Button>
            {downloading
              ? "Downloading..."
              : selectedHubs.length !== 0 && (
                  <BiCloudDownload
                    className="w-10 mt-5 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                    onClick={async () => {
                      await getDownloadData();
                    }}
                  />
                )}
          </div>
        </div>

        {isLoading ? (
          <Spinner />
        ) : (
          <>
            {data && (
              <div className="flex flex-col m-2 lg:m-10">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <TH scope="col">S.N.</TH>
                            <TH scope="col">Date of Alignment</TH>
                            <TH scope="col">Alignment Center</TH>
                            <TH scope="col">Fleet Name</TH>
                            <TH scope="col">Vehicle Number</TH>
                            <TH scope="col">Kilometer Covered</TH>
                            <TH scope="col">Before Alignment Date</TH>
                            <TH scope="col">Total toe (Before)</TH>
                            <TH scope="col">Total toe (After)</TH>
                            <TH scope="col">Thrust angle (Before)</TH>
                            <TH scope="col">Thrust angle (after)</TH>
                            <TH scope="col">Scrub angle (Before)</TH>
                            <TH scope="col">Scrub angle (After)</TH>

                            <TH scope="col">Download</TH>
                            {/* <TH scope="col">Action</TH> */}
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {data &&
                            data.data &&
                            data.data?.map((d, idx) => {
                              // console.log(idx, key)
                              return (
                                <ViewList
                                  page={page}
                                  data={d}
                                  idx={idx}
                                  getData={getData}
                                  prevInspection={
                                    idx != limit - 1 ? data.data[idx + 1] : null
                                  }
                                />
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {data && data.pageInfo && data.pageInfo.total && (
                  <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                    <Button
                      onClick={() => {
                        setPage((p) => Math.max(p - 1, 1));
                      }}
                      disabled={page === 1}
                      className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                      primary
                    >
                      <div className="flex gap-1 items-center">
                        <IoMdArrowBack />
                        Prev Page
                      </div>
                    </Button>
                    <span className="text-gray-600 px-4">{`showing: ${
                      (page - 1) * 20 + 1
                    } - ${Math.min(data?.pageInfo?.total, page * 20)} of ${
                      data.pageInfo.total
                    }`}</span>

                    {data.pageInfo.total > page * 20 && (
                      <Button
                        onClick={() => {
                          setPage((p) =>
                            Math.min(p + 1, data?.pageInfo?.total)
                          );
                        }}
                        disabled={page === data?.pageInfo?.total}
                        className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                        primary
                      >
                        <div className="flex gap-1 items-center">
                          Next Page
                          <IoMdArrowForward />
                        </div>
                      </Button>
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  };
  
  export default WheelAlignmentReport;
  
  const ViewList = ({ data, page, idx, getData, prevInspection }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [showEditModel, setShowEditModel] = useState(false);
    const currentUser = useSelector((state) => state.user.currentUser);
  
    const fetchFile = async (url) => {
      const originalImage = url;
      const image = await fetch(originalImage);
  
      //Split image name
      const nameSplit = originalImage.split("/");
      const duplicateName = nameSplit.pop();
  
      const imageBlog = await image.blob();
      const imageURL = URL.createObjectURL(imageBlog);
      const link = document.createElement("a");
      link.href = imageURL;
      link.download = "" + duplicateName + "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  
    return (
      <Fragment>
        <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
          <TD>{(parseInt(page) - 1) * 20 + (idx + 1)}</TD>
          <TD>{data?.inspectionDate}</TD>
          <TD>{data?.wheelAlignment.alignmentCenter}</TD>
          <TD>{data?.fleetInfo ? `${data.fleetInfo} (${data.fleetCity || "--"})` : "--"}</TD>
          <TD>{data?.vehicleInfo?.registrationNumber}</TD>
          <TD>
            {data?.killometerTravelled}
          </TD>
          <TD>
            {data?.previousAlignmentDate}
          </TD>
          <TD>{data?.wheelAlignment?.totalTOE?.before}</TD>	
                    <TD>{data?.wheelAlignment?.totalTOE?.after}</TD>
                    <TD>{data?.wheelAlignment?.thrustAngle?.before}</TD>
                    <TD>{data?.wheelAlignment?.thrustAngle?.after}</TD>
                    <TD>{data?.wheelAlignment?.scrubAngle?.before}</TD>
                    <TD>{data?.wheelAlignment?.scrubAngle?.after}</TD>
          <TD>
            <BiCloudDownload
              className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer"
              onClick={()=>fetchFile(data?.wheelAlignment.file)}
            />
          </TD>
        </tr>
      </Fragment>
    );
  };
  
  